export const defaultTheme = {
  mention: '',
  // CSS class for suggestions component
  mentionSuggestions: '',
  // CSS classes for an entry in the suggestions component
  mentionSuggestionsEntry: '',
  mentionSuggestionsEntryFocused: '',
  mentionSuggestionsEntryText: '',
  mentionSuggestionsEntryAvatar: '',
};
